module.exports = __webpack_public_path__ + "img/23_70.1c263518.png";